jQuery(document).ready(function ($) {

// Sticky header JS
var header = $(".main-header");
$(window).on("scroll", function () {
  if ($(this).scrollTop() > 10) {
    $(header).addClass("scrolled");
  } else {
    $(header).removeClass("scrolled");
  }
});

  //Menu JS
  $(".hamburger").click(function () {
    $(".hamburger--menu").stop(true, true).slideDown();
    /* Note: For Only POP UP Menu */
    $("body").addClass("js-mobile-menu-open");
    /* Note: For Only POP UP Menu */
    // $(".hamburger").toggleClass("spin");
  });

  $("img.close-hmenu").click(function (e) {
    e.preventDefault();
    $(".hamburger--menu").stop(true, true).slideUp();
    $(".hamburger").removeClass("spin");
    $(".sub-menu").removeClass("arrowopen");

    /* Note: For Only POP UP Menu */
    $("body").removeClass("js-mobile-menu-open");
    $(".sub-menu").removeClass("subMenu");
    /* Note: For Only POP UP Menu */
  });

  $(".mobile-menu .menu-item-has-children > a").append(
    "<span class='arrow'></span>"
  );

  $(".mobile-menu .menu-item-has-children > a span.arrow").click(function (e) {
    e.preventDefault();

    $(this)
      .parents("a")
      .next(".sub-menu")
      .stop(true, true)
      .toggleClass("subMenu");

    $(this).toggleClass("arrowopen");

    let currentParent = $(this).parents("li");

    // Remove Submenu class from of any other li that's not the current li clicked

    $("li.menu-item-has-children")
      .not(".sub-menu li.menu-item-has-children")
      .not(currentParent)
      .find("ul")
      .removeClass("subMenu");

    // Remove arrowopen class from any other li (Not submenu li) that's not the currently clicked parent menu
    $("li.menu-item-has-children")
      .not(".sub-menu li.menu-item-has-children")
      .not(currentParent)
      .find("a span.arrow")
      .removeClass("arrowopen");
  });

  $(window).resize(function () {
    var winwidth = $(window).width();
    if (winwidth > 1160) {
      $(".hamburger--menu").stop(true, true).slideUp();
      $(".hamburger").removeClass("spin");
      $("body").removeClass("js-mobile-menu-open");
    }
  });

  // Get the dimensions and position of the Nav Menu

  function subMenuPosition(Nav) {
    var NavWidth = Nav.width();
    var NavHeight = Nav.height();
    var NavOffset = Nav.offset();
    var NavLeft = NavOffset.left;
    var NavTop = NavOffset.top;

    // Get the dimensions of the viewport
    var viewportWidth = $(window).width();
    var viewportHeight = $(window).height();

    // Check if the Nav is going off the screen
    var isNavGoingOffScreen =
      NavLeft < 0 ||
      NavLeft + NavWidth > viewportWidth ||
      NavTop < 0 ||
      NavTop + NavHeight > viewportHeight;

    return isNavGoingOffScreen;
  }

  // var subMenu = $("li.menu-item-has-children");
  // $(subMenu).hover(function () {
  //   var Nav = $($(this).find(".sub-menu"));
  //   var isNavGoingOffScreen = subMenuPosition(Nav);

  //   if (isNavGoingOffScreen) {
  //     Nav.css("right", "0px");
  //   }
  // });

  var subMenu = $(
    "li.menu-item-has-children .sub-menu li.menu-item-has-children"
  );
  $(subMenu).hover(function () {
    var Nav = $($(this).find(".sub-menu"));
    var isNavGoingOffScreen = subMenuPosition(Nav);
    if (isNavGoingOffScreen) {
      Nav.css("right", "100%");
      Nav.css("left", "unset");
    }
  });

  //Vide Background JS
  function scaleToFill() {
    $("video.video-background").each(function (videoTag) {
      var $video = $(videoTag),
        videoRatio = videoTag.videoWidth / videoTag.videoHeight,
        tagRatio = $video.width() / $video.height(),
        val;

      if (videoRatio < tagRatio) {
        val = (tagRatio / videoRatio) * 1.02;
      } else if (tagRatio < videoRatio) {
        val = (videoRatio / tagRatio) * 1.02;
      }

      $video.css("transform", "scale(" + val + "," + val + ")");
    });
  }

  $(function () {
    scaleToFill();

    $(".video-background").on("loadeddata", scaleToFill);

    $(window).resize(function () {
      scaleToFill();
    });
  });

  $(".mt-video .play").click(function () {
    if ($(this).parent().prev().get(0).paused) {
      $(this).parent().prev().get(0).play();
      $(this).parent().prev().removeClass("blurEffect");
      $(this).parent().prev().attr("controls", "controls");
      $(this).hide();
    } else {
      $(this).parent().prev().get(0).pause();
      $(this).fadeIn();
      $(this).parent().prev().removeAttr("controls");
    }
  });

  $(".mt-video .video").on("ended", function () {
    $(this).addClass("blurEffect");
    $(this).removeAttr("controls");
    $(this).parent().find(".play").fadeIn();
  });

  if ($(".banner-slide").length > 1) {
    $(".banner-slide").slick({
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 500,
      fade: true,
      lazyLoad: "progressive",
      cssEase: "linear",
      prevArrow:
        '<button type="button" class="slick-arrow slick-prev"></button>',
      nextArrow:
        '<button type="button" class="slick-arrow slick-next"></button>',
      responsive: [
        {
          breakpoint: 1161,
          settings: {
            arrows: false,
            adaptiveHeight: true,
          },
        },
      ],
    });
  }

  var menuNav = $(".menu-sidebar-menu-container ul li a");

  let pathname = window.location.pathname.replace(/\//g, "");
  $(menuNav).each(function () {
    var href = $(this).attr("href").split("/");
    btnPathname = href[3];
    if (pathname == btnPathname) {
      $(this).addClass("active");
    }
  });

  // mini FAQ Js

  var openFaq = false;
  $(".minifaq--listing div.question").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("open");
    $(this).siblings().stop(true, true).slideToggle();
    $(".minifaq--listing div.question")
      .not(this)
      .removeClass("open")
      .siblings()
      .slideUp();
    $(".minifaq--listing .inner--question div.minifaq--icon")
      .not(this)
      .html('<span class="close"></span>');
    if ($(this).hasClass("open")) {
      $(this)
        .find(".inner--question")
        .children(".minifaq--icon")
        .html('<span class="open"></span>');

      $(this)
        .find(".inner--question .sub")
        .children(".minifaq--icon")
        .html('<span class="open"></span>');
    } else {
      $(this)
        .find(".inner--question")
        .children(".minifaq--icon")
        .html('<span class="close"></span>');

      $(this)
        .find(".inner--question .sub")
        .children(".minifaq--icon")
        .html('<span class="close"></span>');
    }
  });

  // FAQ Js
  $(".faq--listing div.question").click(function (e) {
    e.preventDefault();
    console.log("Hey");
    $(this).toggleClass("open");
    $(this).siblings().stop(true, true).slideToggle();
    $(".faq--listing div.question")
      .not(this)
      .removeClass("open")
      .siblings()
      .slideUp();
    $(".faq--listing div.faq--icon")
      .not(this)
      .html('<span class="close"></span>');

    $(".faq--listing div.faq--icon").not(this).removeClass("active");

    if ($(this).hasClass("open")) {
      $(this)
        .find(".faq--icon")
        .addClass("active")
        .html('<span class="open"></span>');
    } else {
      $(this)
        .find(".faq--icon")
        .removeClass("active")
        .html('<span class="close"></span>');
    }
  });

  // Counter JS

  function animateValue(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(
        progress * (end - start) + start
      ).toLocaleString(); // Add commas
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  const obj = document.querySelectorAll(".box-item #value");
  obj.forEach((item) => {
    const countValue = parseFloat(item.innerText.replace(/,/g, "")); // Remove commas and parse as float

    // Only run animation if countValue is an integer (no decimal points)
    if (Number.isInteger(countValue)) {
      animateValue(item, 0, countValue, 5000);
    }
  });

  // Show Form on BTN Click
  var slideBtnId = $("#slide-form");
  var formToShow = $(".slide-form-content");
  $(slideBtnId).click(function (e) {
    e.preventDefault();
    $(formToShow).slideDown();
  });

  //Gallery Carousel (Slick Js)

  $(".gallery-slide").slick({
    dots: false,
    arrows: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });


  // Slick Testimonial JS
  $(".testimonial-slide").slick({
    autoplay: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    speed: 500,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1161,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: "80px",
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: "50px",
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "20px",
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  //Testimonial JS

  var tesOpen = false;
  $(".readMoreTes").click(function (e) {
    e.preventDefault();
    if (!tesOpen) {
      $(this).parents(".tesBody").find(".fullTes").stop(true, true).slideDown();
      // $(this)
      //   .parents(".tesBody")
      //   .find(".firstSpan")
      //   .stop(true, true)
      //   .css('margin-top', '30px');
      $(this).parents(".tesBody").find(".dots").stop(true, true).hide();
      $(this).stop(true, true).text("Read Less >>");
      tesOpen = true;
    } else {
      $(this).parents(".tesBody").find(".fullTes").stop(true, true).slideUp();
      //  $(this)
      //    .parents(".tesBody")
      //    .find(".firstSpan")
      //    .stop(true, true)
      //    .css("margin-top", "0px");
      $(this).parents(".tesBody").find(".dots").stop(true, true).show();
      $(this).stop(true, true).text("Read More >>");

      tesOpen = false;
    }
    $(".readMoreTes").not($(this)).text("Read More >>");
    $(".tesBody")
      .find(".fullTes")
      .not($(this).parents(".tesBody").find(".fullTes"))
      .stop(true, true)
      .slideUp();
  });
});
